import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import Pagination10 from '../Pagination10';
import usePagination10 from '../hooks/usePagination10';
import LoadingModal from './LoadingModal';

function EntidadeSearchModal({ show, onClose, onSelect }) {
  const [entidades, setEntidades] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [entidadeSelecionada, setEntidadeSelecionada] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (show) {
      setIsLoading(true);
      axios
        .get(`${API_BASE_URL.ENTIDADE}/all`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(result => {
          setEntidades(result.data);
        })
        .catch(error => {
          console.error('Erro ao obter entidades:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      // Limpar quando fechar
      setFiltro('');
      setEntidadeSelecionada(null);
    }
  }, [show, token]);

  const normalizeString = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  const entidadesFiltradas = Array.isArray(entidades)
    ? entidades.filter(c => {
        const normalizedBusca = normalizeString(filtro);
        return (
          normalizeString(c.nome || '').includes(normalizedBusca) ||
          normalizeString(c.cnpj || '').includes(normalizedBusca) ||
          normalizeString(c.logrCidade || c.municipio || '').includes(
            normalizedBusca
          ) ||
          normalizeString(c.logrUf || c.uf || '').includes(normalizedBusca)
        );
      })
    : [];

  const totalItems = entidadesFiltradas.length;
  const { setPagination } = usePagination10(totalItems);
  const selectedEntidades = entidadesFiltradas.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  const handleSelecionar = () => {
    if (entidadeSelecionada && onSelect) {
      onSelect(entidadeSelecionada);
    }
  };

  const handleRowClick = entidade => {
    setEntidadeSelecionada(entidade);
  };

  const handleDoubleClick = entidade => {
    if (onSelect) {
      onSelect(entidade);
    }
  };

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: '90vw', width: '900px' }}
        >
          <div className="modal-content" style={{ maxHeight: '85vh', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div
              className="modal-header text-white"
              style={{
                background:
                  'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
                padding: '0.35rem 0.75rem',
                border: 'none',
                flexShrink: 0,
              }}
            >
              <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
                <h6 className="modal-title mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}>
                  <i className="bi bi-building me-2"></i>
                  Buscar Entidade
                </h6>
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-link text-white p-0 mb-0"
                    onClick={onClose}
                    title="Fechar"
                    style={{ fontSize: '1rem', textDecoration: 'none' }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-body" style={{ padding: '1rem' }}>
              {/* Filtro de pesquisa */}
              <div className="mb-3">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">
                    <i className="bi bi-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Buscar por CNPJ, Nome ou Cidade"
                    value={filtro}
                    onChange={e => setFiltro(e.target.value.toUpperCase())}
                  />
                </div>
              </div>

              <LoadingModal loading={isLoading} />

              {/* Tabela de resultados */}
              <div
                style={{
                  overflowY: 'auto',
                  overflowX: 'auto',
                  maxHeight: 'calc(85vh - 200px)',
                }}
              >
                <table
                  className="table table-hover table-striped table-sm small"
                  style={{ minWidth: '600px' }}
                >
                  <thead className="sticky-top" style={{ background: 'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)', color: '#fff', '--bs-table-color': '#fff' }}>
                    <tr>
                      <th scope="col" style={{ minWidth: '140px' }}>
                        CNPJ
                      </th>
                      <th scope="col" style={{ minWidth: '250px' }}>
                        Nome
                      </th>
                      <th scope="col" style={{ minWidth: '150px' }}>
                        Cidade
                      </th>
                      <th scope="col" style={{ minWidth: '60px' }}>
                        UF
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedEntidades.length > 0 ? (
                      selectedEntidades.map(c => (
                        <tr
                          key={c.cnpj}
                          className={
                            entidadeSelecionada &&
                            entidadeSelecionada.cnpj === c.cnpj
                              ? 'table-primary'
                              : ''
                          }
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleRowClick(c)}
                          onDoubleClick={() => handleDoubleClick(c)}
                          title="Clique para selecionar, duplo clique para confirmar"
                        >
                          <td>{c.cnpj}</td>
                          <td>{c.nome}</td>
                          <td>{c.logrCidade || c.municipio || '-'}</td>
                          <td>{c.logrUf || c.uf || '-'}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          Nenhuma entidade encontrada.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div style={{ padding: '0.5rem 1rem', borderTop: '1px solid rgba(0,0,0,0.1)', backgroundColor: '#f8f9fa' }}>
                <Pagination10 {...setPagination} />
              </div>
            </div>
            <div className="modal-footer" style={{ padding: '0.5rem 1rem' }}>
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={onClose}
              >
                <i className="bi bi-x-circle me-1"></i>
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={handleSelecionar}
                disabled={!entidadeSelecionada}
              >
                <i className="bi bi-check-circle me-1"></i>
                Selecionar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EntidadeSearchModal;
